<div class="row border rounded p-2 mb-2 ms-1 me-1" style="overflow-x: auto;">
    <div *ngIf="!isOnline" class="offline-banner">
        <i class="fa-solid fa-plug-circle-xmark"></i> You are currently offline.
    </div>
    <div *ngIf="noTradeUnitAssigned" class="config-warning-banner">
        <i class="fa-solid fa-triangle-exclamation"></i> No trade unit is assigned to your account. Contact your administrator to assign one.
    </div>
    <div *ngIf="!noTradeUnitAssigned && compuweighNotEnabled" class="config-warning-banner">
        <i class="fa-solid fa-triangle-exclamation"></i> Location {{locDisplayCode}} is not enabled for Compuweigh. Contact your administrator to enable it.
    </div>
    <form role="form">
        <div class="row row-cols-lg-auto g-2 align-items-center">
            <label class="col-form-label-sm">Loc:</label>
            <div class="col-12">
                <select name="locCode" class="form-select form-select-sm select-m" (change)="onLocCodeChange()" [(ngModel)]="scheduleParameters.locCode">
                    <option *ngFor="let item of locList" value="{{item.value}}">{{item.text}}</option>
                </select>
            </div>
            <label class="col-form-label-sm">Plan Period:</label>
            <div class="col-12">
                <select name="planPeriod" class="form-select form-select-sm" (change)="onPlanPeriodChange()" [(ngModel)]="scheduleParameters.planPeriod">
                    <option *ngFor="let item of planPeriods" [value]="item.value">{{item.text}}</option>
                </select>
            </div>
            <div class="col-12">
                <input type="date" name="planStartDate" class="form-control form-control-sm date-input"
                       [disabled]="scheduleParameters.planPeriod !== 'Custom'"
                       [(ngModel)]="scheduleParameters.periodStartDate" />
            </div>
            <div class="col-12">
                -
            </div>
            <div class="col-12">
                <input type="date" name="planEndDate" class="form-control form-control-sm date-input"
                       [disabled]="scheduleParameters.planPeriod !== 'Custom'"
                       [(ngModel)]="scheduleParameters.periodEndDate" />
            </div>
            <div class="col-12">
                <button type="button" class="btn btn-sm btn-success"
                        (click)="duplicateSelectedLoad()"
                        [disabled]="!selectedLoad || isAddingLoad || !isOnline || compuweighNotEnabled"
                        [title]="compuweighNotEnabled ? 'Location is not enabled for Compuweigh' : ''">
                    <span *ngIf="!isAddingLoad">Add Load</span>
                    <span *ngIf="isAddingLoad">
                        <span class="spinner-border spinner-border-sm me-1"></span>
                        <span>Adding...</span>
                    </span>
                </button>
            </div>
            <div class="col-12">
                <button type="button" class="btn btn-sm btn-primary"
                        (click)="loadScaleViewData()"
                        [disabled]="isLoadingData">
                    <span *ngIf="!isLoadingData">Refresh</span>
                    <span *ngIf="isLoadingData">
                        <span class="spinner-border spinner-border-sm me-1"></span>
                        <span>Loading...</span>
                    </span>
                </button>
            </div>
            <div class="col-12 text-muted small" *ngIf="lastRefreshed">
                Last Refreshed: {{lastRefreshed | date:'M/d/yy h:mm a'}}
            </div>
            <div class="col-12">
                <div class="form-check small">
                    <input class="form-check-input" type="checkbox" id="showAllCheckbox"
                           [(ngModel)]="includeDeliveredAndPreadvised"
                           name="includeDeliveredAndPreadvised"
                           (change)="loadScaleViewData()">
                    <label class="form-check-label" for="showAllCheckbox">
                        Show All
                    </label>
                </div>
            </div>
            <div class="col-12 text-danger" *ngIf="invalidDateRange">
                Invalid date range entered
            </div>
            <div class="col-12 text-danger" *ngIf="errorMessage">
                {{errorMessage}}
            </div>
        </div>
    </form>
    <div class="m-1">
        <pqgrid #scaleViewGrid [options]="scaleViewOptions"></pqgrid>
    </div>
</div>

<div class="toast-container" *ngIf="showToast">
    <div class="toast-message" [ngClass]="'toast-' + toastType">
        <i class="fa-solid" [ngClass]="toastType === 'error' ? 'fa-circle-xmark' : 'fa-check-circle'"></i> {{toastMessage}}
    </div>
</div>